import _ from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import TableRow from '@material-ui/core/TableRow';

class EnhancedTableHead extends Component {
	createSortHandler(event, property) {
		this.props.onRequestSort(event, property);
	}

	render() {
		const { columnData, order, orderBy } = this.props;

		return (
			<TableHead>
				<TableRow>
					{columnData.map((column) => {
						const { isNotSortable, align } = column;

						//let finalPadding = padding || 'default';
						//if (disablePadding) { finalPadding = 'none'; }

						const style = _.merge(
							{
								backgroundColor: 'white',
								color: `rgba(0, 0, 0, 0.54)`,
								fontSize: 12,
								fontWeight: 500,
								//zIndex : 1,
								//position: 'sticky',
								//top : 0,
							},
							column.style
						);

						let columnLabel;
						if (column.label) {
							columnLabel = column.label;
						} else if (column.labels) {
							const separator = column.noSeparator ? '' : ' /';
							columnLabel = (
								<div style={{ lineHeight: 1.4 }}>
									{column.labels.map((label, i) => {
										return (
											<div key={label}>
												{label}
												{!i ? separator : ''}
											</div>
										);
									})}
								</div>
							);
						} else {
							columnLabel = 'Missing label';
						}

						return (
							<TableCell
								key={column.id}
								align={column.numeric ? 'right' : align ? align : 'left'}
								style={style}
							>
								{isNotSortable && <span style={{ whiteSpace: 'nowrap' }}>{columnLabel}</span>}

								{!isNotSortable && (
									<TableSortLabel
										active={orderBy === column.id}
										direction={order}
										onClick={() => {
											this.createSortHandler(column.id);
										}}
									>
										<span style={{ whiteSpace: 'nowrap' }}>{columnLabel}</span>
									</TableSortLabel>
								)}
							</TableCell>
						);
					}, this)}
				</TableRow>
			</TableHead>
		);
	}
}

EnhancedTableHead.propTypes = {
	columnData: PropTypes.array.isRequired,
	onRequestSort: PropTypes.func.isRequired,
	order: PropTypes.string.isRequired,
	orderBy: PropTypes.string.isRequired,
};

export default EnhancedTableHead;
